import React from 'react';
import Loadable from 'react-loadable';
import { Loading } from '../components/common';

const LoadingHandler = ({ error }: Object) => {
  if (error) {
    return <div>Error: {error}</div>;
  }
  return <Loading />;
};

export const PageNotFound = Loadable({
  loader: () => import('./PageNotFound'),
  loading: LoadingHandler,
});

export const OrderTracking = Loadable({
  loader: () => import('../components/OrderTracking/OrderTracking'),
  loading: LoadingHandler,
});

export const OnlineOrder = Loadable({
  loader: () => import('../components/OnlineOrder/OnlineOrder'),
  loading: LoadingHandler,
});

export const OnlineCancel = Loadable({
  loader: () => import('../components/OrderDetails/OnlineCancel/OnlineCancel'),
  loading: LoadingHandler,
});

export const OnlineReturns = Loadable({
  loader: () =>
    import('../components/OrderDetails/OnlineReturns/OnlineReturns'),
  loading: LoadingHandler,
});

export const OnlineReceipt = Loadable({
  loader: () =>
    import('../components/OrderDetails/OnlineReceipt/OnlineReceipt'),
  loading: LoadingHandler,
});

export const OrderHistory = Loadable({
  loader: () => import('../components/OrderSummary/OrderSummary'),
  loading: LoadingHandler,
});

export const ApplianceCancel = Loadable({
  loader: () => import('../components/OrderDetails/ApplianceCancel'),
  loading: LoadingHandler,
});

export const AuthInstoreOrder = Loadable({
  loader: () => import('../components/InstoreSummary/InstoreSummaryTracking'),
  loading: LoadingHandler,
});

export const eReceipts = Loadable({
  loader: () => import('../components/eReceipts/eReceiptSummary'),
  loading: LoadingHandler,
});

export const RatingsReviews = Loadable({
  loader: () => import('../components/RatingsAndReviews/RatingsReviews'),
  loading: LoadingHandler,
});
